export default "__VITE_ASSET__24ae1cf0__"